import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Container, Grid, LinearProgress } from "@mui/material";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import QualificationCard from "./QualificationCard";
import Error404 from "../../../Errors/Error404";
import Error500 from "../../../Errors/Error500";

import { ActionTypes } from "../../../../constants";
import {
    getQualification,
    getRmsAppCode,
    getError,
} from "../../../../reducers";
import { getQualificationDetails } from "../../../../actions/rmsActions";

function Qualification({
    match,
    qualification,
    getQualificationDetails,
    error,
    appCode,
}) {
    useEffect(() => {
        getQualificationDetails(match.params.id, appCode);
    }, [getQualificationDetails, match.params.id, appCode]);

    if (!!error) {
        if (error.errorCode === 404) {
            return <Error404 />;
        }
        if (error.errorCode === 500) {
            return <Error500 />;
        }
    }

    if (!qualification) return <LinearProgress />;

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <QualificationCard qualification={qualification} />
                </Grid>
            </Grid>
        </Container>
    );
}

const mapStateToProps = (state, { match }) => ({
    qualification: getQualification(state, Number(match.params.id)),
    error: getError(state, ActionTypes.GET_QUALIFICATION_SUCCESS),
    appCode: getRmsAppCode(state),
});

export default connect(mapStateToProps, { getQualificationDetails })(
    Qualification
);
